import { Stack, Typography } from '@mui/material';
import PauseCircleOutlined from '@mui/icons-material/PauseCircleOutlined';
import { type SessionType } from '@/types/dtos/sessions/session-type.enum';
import { useTranslations } from '@/i18n/use-translations';
import sessionTypeToIcon from '@/components/events/detail/tabs/sessions/helpers/session-type-to-icon.helper';

interface SessionTypeInfoProps {
  type: SessionType;
  showDescription?: boolean;
}

const SessionTypeInfo: React.FC<SessionTypeInfoProps> = ({ type, showDescription = true }) => {
  const t = useTranslations();
  const description = t(`session.typeDescriptions.${type}`);

  const iconElement = sessionTypeToIcon(type);
  const title = t(`session.types.${type}`);

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Stack sx={{ fontSize: 24 }}>{iconElement}</Stack>

      <Stack spacing={0} sx={{ flex: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        {showDescription && (
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

/** Same layout as `SessionTypeInfo` — for flow inline create (break vs session types). */
export function BreakSlotTypeInfo({ showDescription = true }: { showDescription?: boolean }) {
  const t = useTranslations();
  const title = t('flows.detail.slotList.actions.break.title');
  const description = t('flows.detail.slotList.actions.break.description');

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Stack sx={{ fontSize: 24 }}>
        <PauseCircleOutlined fontSize="inherit" />
      </Stack>

      <Stack spacing={0} sx={{ flex: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        {showDescription && (
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

export default SessionTypeInfo;
